module.exports = __webpack_public_path__ + "img/组 9707@2x.19db4195.png";